import { useNavigate, useParams } from "react-router";
import { api } from "@src/utils/axios-instance";
import { useEffect } from "react";
import toast from "react-hot-toast";
import Loader from "@src/components/Loader/Loader";

const UserConfirm = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    async function confirmUser() {
        try {
            const res = await api.get("/users/confirm_email/" + token);
            toast.success(res.data);
        } catch (error: any) {
            toast.error(error.message);
        } finally {
            navigate("/");
        }
    }
    useEffect(() => {
        confirmUser();
    }, []);

    return (
        <div>
            <Loader />
            <div>
                Beep boop, we're validating your account, just give it a second
                or two...
            </div>
        </div>
    );
};
export default UserConfirm;
